import { useRef, useState } from 'react'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import DigitalAddressDetails, { DigitalAddressHandler } from './digital-address-details';
import { useMutation } from '@apollo/client';
import SpinnerOverlay from '../../../common/spinner/spinner';
import { AddIcon, CancelIcon } from '../../../common/icons';
import { CREATE_ORG_DIGITAL_ADDRESS, GET_ORG_DIGITAL_ADDRESSES } from '../../../../graphql/contact-gql';
import { notifySuccess } from '../../../../services/notification';
import Button from '../../../common/button';

type DigitalAddressCreateProps = {
    orgId: number;
    isOpen: boolean;
    toggle: () => void;
}

const DigitalAddressCreate = (props: DigitalAddressCreateProps) => {
    const {orgId, isOpen, toggle} = props

    const [createDigitalAddress, {loading}] = useMutation(CREATE_ORG_DIGITAL_ADDRESS)
    const [validated, setValidated] = useState<boolean>(false)

    const digitalAddressRef = useRef<DigitalAddressHandler>(null)

    const onCreateDigitalAddress = () => {
        if (digitalAddressRef.current && !digitalAddressRef.current.validate(true)) {
            setValidated(false)
            return
        }
        let digitalAddressInput = digitalAddressRef.current && digitalAddressRef.current.getDigitalAddress()
        createDigitalAddress({
            variables: {
                orgId: orgId,
                input: digitalAddressInput
            },
            refetchQueries: [{
                query: GET_ORG_DIGITAL_ADDRESSES,
                variables: { orgId: orgId }
            }],
            awaitRefetchQueries: true,
            onCompleted: (data) => {
                toggle()
                data && notifySuccess()
            }
        })
    }

    const onToggle = (event: any) => {
        if (event.target.nodeName !== 'SELECT') {
            toggle()
        }
    }

    const onChange = () => {
        setValidated(!!digitalAddressRef.current?.validate(false))
    }

    return (<>
        {loading && <SpinnerOverlay />}
        <Modal size="lg" isOpen={isOpen} toggle={onToggle} scrollable backdrop="static" autoFocus={false}>
            <ModalHeader toggle={toggle} tag={'h2'}>Add an Organization Digital Address</ModalHeader>
            <ModalBody>
                <DigitalAddressDetails ref={digitalAddressRef} onChange={onChange} autoFocus={true}/>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={onCreateDigitalAddress} disabled={!validated}><AddIcon/> Add</Button>
                <Button color="secondary" onClick={toggle}><CancelIcon/> Cancel</Button>
            </ModalFooter>
        </Modal>
        </>
    )
}

export default DigitalAddressCreate
